__turbopack_context__.v({
  "container": "styles-module__ffmtsW__container",
});
